import React, { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";

import ACTIONS from "../../../pages/DesignAssets/Design_Asset_Actions.json";
import MyErrorBoundary from "../../../utils/ErrorBoundary";
import useCBMouserOver from "../../../pages/CustomHooks/useCBMouserOver";
import UtilitySVG from "../SLD/UtilitySVG";
import PowerMeterSVG from "../SLD/PowerMeterSVG";
import CircuitBreakerSVG from "../SLD/CircuitBreakerSVG";
import embLabels from "../../../config/emb-labels-en.json";

const Utility = () => {
  const {
    CBAssetList: [{ uiData, configData, powerMeterData, cbConfigData }],
    UserScope,
    assetDetailsDisplay,
    CBAssetListDispatch,
    assetDetailsReset,
    callSnackbar,
    selectedValuesHandler,
    assetConfigDataHandler,
    setAssetDetailsDisplay,
    switchboardType,
    newSBCbConfigDataHandler,
    
  } = useContext(DesignAssetContext);
  const [mouseOverData, CBMouseHandler] = useCBMouserOver();
  const utilitySelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "assetUtilityDetailsBlock";
      const selectedAssetValue = "selectedAsset";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_SELECT,
        payload: {
          index: 0,
          assetDetailsDisplay,
          setAssetDetailsDisplay,
        },
      });
      selectedValuesHandler(0, selectedAssetValue, assetBlock);
      assetConfigDataHandler(0);
    } else {
      callSnackbar(
        "error",
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
  
  const utilityCBSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "newSBCbAssetDetailsBlock";
      const selectedAssetValue = "selectedAssetCB";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_CB_SELECT,
        payload: {
          index: 0,
        },
      });
      selectedValuesHandler(0, selectedAssetValue, assetBlock);
      newSBCbConfigDataHandler(0);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  return (
    <MyErrorBoundary>
      <>
        {
          <svg className="pointer"  x={switchboardType === embLabels?.EXISTING_SWITCHBOARD ? -250 : 0} y={switchboardType === embLabels?.EXISTING_SWITCHBOARD ? -100 : 0}>
            <UtilitySVG
              x={370}
              y="141"
              handler={utilitySelectHandler}
              configData={configData}
              uiData={uiData}
            />
            <PowerMeterSVG
            id = {"_Utility"}
              x="375"
              y="127.5"
              index ={0}
              powerMeterData={powerMeterData}
              uiData={uiData}
            />
            <CircuitBreakerSVG 
               id = {"_Utility"}
               x ={"470.5"}
              y ={"270"}
              index ={0}
              cbRequiredSelection={switchboardType === embLabels?.EXISTING_SWITCHBOARD?false:true}
              utilityCBSelectHandler={utilityCBSelectHandler}
              CBMouseHandler={CBMouseHandler}
              uiData={uiData}
              mouseOverData={mouseOverData}
              dummyCB={switchboardType === embLabels?.EXISTING_SWITCHBOARD?true:false}
              name={cbConfigData?.name}
            />
           
          </svg>
        }
    
      </>
    </MyErrorBoundary>
  );
};

export default Utility;
